import React from 'react';
import EditAction from '@/components/ribbon-actions/EditAction';
import CancelDatasetAction from '../containers/CancelDatasetAction';
import SaveDatasetAction from '../containers/SaveDatasetAction';
import ViewDatasetAction from '../containers/ViewDatasetAction';
import DuplicateDatasetAction from '../containers/DuplicateDatasetAction';
import DatasetWizardAction from '../containers/DatasetWizardAction';

const DatasetActionEditMenus = ({
  category,
  code,
  disableEdit,
  isEditing,
  showEdit,
  template,
}) => (
  <>
    {!isEditing && (<EditAction onClick={() => showEdit(category, code, template)} disabled={disableEdit} />)}
    {isEditing && (<CancelDatasetAction code={code} category={category} />)}
    <SaveDatasetAction code={code} category={category} isEditing={isEditing} />
    <ViewDatasetAction code={code} category={category} />
    {isEditing && (<DatasetWizardAction code={code} category={category} />)}
    {!isEditing && (<DuplicateDatasetAction code={code} category={category} />)}
  </>
);

export default DatasetActionEditMenus;
